<template>
  <v-container fluid grid-list-md>
    <!--    <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>-->
    <v-layout row justify-center align-center>
      <v-flex xs12 md8>
        <v-card>
          <card-toolbar title="Excel İle Whatsapp Mesajı Gönder"> </card-toolbar>
          <div style="padding: 15px;" v-if="!whatsappStatus">
            <v-alert type="warning">Whatsapp numaranız aktif değil. <a href="/whatsapp/settings" style="color:#fff">Buraya</a> tıklayarak veya Ayarlar sayfasına giderek numaranızı aktive edebilirsiniz.</v-alert>
          </div>
          <v-card-text>
            <v-form ref="excelForm" lazy-validation>
              <v-layout wrap>
                <v-flex xs6>
                  <v-file-input
                    label="Mesaj Gönderilecek Excel Dosyasını Seçiniz"
                    placeholder="Whatsapp Mesajı gönderilecek Excel dosyanızı seçiniz."
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    v-model="files"
                    validate-on-blur
                    :rules="[
                      $rules.empty('Dosya'),
                      () => !!files.name || 'Excel Dosya Alanı gerekli',
                    ]"
                    required
                  >
                  </v-file-input>
                </v-flex>
                <v-flex xs6>
                  <v-file-input
                      label="Whatsapp mesajına dosya ekleyebilirsiniz."
                      placeholder="Whatsapp mesajına eklemek istediğiniz dosyayı seçiniz."
                      v-model="attachment"
                      validate-on-blur
                      @change="handleAttachmentChange"
                  >
                  </v-file-input>
                </v-flex>
                <v-flex xs6>
                  <!-- DELAY SEÇENEĞİ -->
                  <v-select
                      v-model="delay"
                      :items="delayOptions"
                      label="Gönderim Hızı"
                      required
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <senders
                    label="Gönderici Adı"
                    required
                    no-data-text="Aktif Gönderici Adı bulunmuyor"
                    :default="data.sender"
                    :items="senders"
                    item-text="text"
                    item-value="value"
                    :rules="[$rules.empty('Gönderici Adı')]"
                    @on:model-update="
                      (val) => {
                        data.sender = val;
                      }
                    "
                  >
                  </senders>
                </v-flex>
                <v-flex xs12  v-if="previewUrl">
                  <img :src="previewUrl" alt="Preview" v-if="isImage" style="max-width: 10%;" />
                </v-flex>
              </v-layout>
            </v-form>
            <div class="text-right">
              <whatsapp-confirmation
                :context="confirmation.context"
                :valid="confirmation.valid"
                :isDisabled="this.isDisabled"
                @on:disagree="
                  () => {
                    $trigger('setPluginDialog');
                    confirmation.valid = !confirmation.valid;
                  }
                "
                @on:agree="sendExcel"
              >
                <template v-slot:activator>
                  <v-btn color="primary" @click="whatsappPreview" :disabled="!whatsappStatus ? true : false">
                    Mesajı Gönder <v-icon right dark>mdi-send</v-icon>
                  </v-btn>
                </template>
              </whatsapp-confirmation>
              <excel-button type="number_message"> </excel-button>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';
import { types } from '../../../../misc';
import Senders from '../../../Components/WhatsappConstants/Senders.vue';
import CardToolbar from '../../../Components/CardToolbar.vue';
import ExcelButton from '../../../Components/Whatsapp/ExcelButton.vue';
import WhatsappConfirmation from '../../../Components/WhatsappConfirmation.vue';
import checkWebsite from '@/mixins/computed/check-website';

export default {
  name: 'Excel',
  components: {
    WhatsappConfirmation,
    CardToolbar,
    Senders,
    ExcelButton,
  },
  mixins: [checkWebsite],
  data: () => ({
    whatsappStatus: true,
    dateSelected: false,
    types,
    files: [],
    delayOptions: [
      { text: 'Çok Hızlı (5 saniye de bir)', value: 1 },
      { text: 'Hızlı (10 saniye de bir)', value: 2 },
      { text: 'Orta (20 saniye de bir)', value: 3 },
      { text: 'Yavaş (35 saniye de bir)', value: 4 },
    ],
    delay: null,
    attachment: [],
    previewUrl: null,
    attachmentName: null,
    isImage: false,
    data: {},
    confirmation: {
      valid: false,
      context: {
        examples: [],
      },
    },
    isDisabled: false,
    senders: [],
    defaultMessage: '',
    defaultLink: '/v/f58d59',
    messageHolder: '',
  }),
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    handleAttachmentChange() {
      const file = this.attachment;

      if (file) {
        this.isImage = file.type.startsWith('image/');
        this.previewUrl = this.isImage ? URL.createObjectURL(file) : null;
        this.fileName = file.name;
      } else {
        this.previewUrl = null;
        this.fileName = null;
        this.isImage = false;
      }
    },
    sendExcel() {
      if (this.$refs.excelForm.validate()) {
        this.isDisabled = true;
        const form = this.prepareOriginal();
        this.send({
          route: 'whatsapp/excel/nm/send',
          data: form,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).finally(() => {
          this.isDisabled = false;
        });
      }
    },
    whatsappPreview() {
      if (this.confirmation.valid) {
        this.confirmation.valid = false;
        this.$trigger('setPluginDialog');
      }
      this.confirmation.valid = this.$refs.excelForm.validate();
      if (this.$refs.excelForm.validate()) {
        const form = this.prepareOriginal();
        this.send({
          route: 'whatsapp/excel/nm/send/preview',
          data: form,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then((res) => {
          this.confirmation.context = res.data.data;
        });
      }
    },
    prepareOriginal() {
      this.data.excel = this.files;

      const form = new FormData();
      form.append('excel', this.data.excel);
      form.append('sender', this.data.sender);
      form.append('attachment', this.attachment);
      form.append('delay', this.delay);

      return form;
    },
  },
  created() {
    this.defaultLink = (this.isVatan
        ? 'vatansms.net'
        : 'toplusmspaketleri.com') + this.defaultLink;
    this.data.bridge = this.isVatan ? 'vatansms.net' : 'toplusmspaketleri.com';
    this.delay = this.delayOptions.find(option => option.text === "Çok Hızlı (5 saniye de bir)").value;
    const route = 'whatsapp/excel/nm';
    this.send({ route }).then(async (res) => {
      this.data = await res.data.data;
      this.senders = res.data.data.senders;
      this.data.sender = this.senders[0];
    });

    Vue.axios({
          url: `${this.$store.getters.apiEndpoint}whatsapp/check-device-active`,
          data: {},
          method: 'POST',
          statusCode: 500,
          responseType: 'JSON',
        }).then((res) => {
          this.whatsappStatus = res.data.data.device || res.data.data.other_devices && res.data.data.account_status;
        });
  },
};
</script>
